import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import ProfilePicture from "../../../Presentational/Person/ProfilePicture/ProfilePicture";
import FAIcon from "../../../UI/FAIcon/FAIcon";
import PersonPhoneDomainService from "../../../../Domain/PersonPhone/PersonPhone.service";
import DateService from "../../../../Services/Shared/Date.service";
import PageTitle from "../../../UI/PageTitle/PageTitle";
const StaffAboveTabs = ({ staff }) => {
    const phoneVerifiedTitle = React.useMemo(() => {
        if (staff.preferredPhone == null) {
            return "";
        }
        if (staff.preferredPhone.verifierFullName == null) {
            return "Preferred Phone";
        }
        let verifiedDateLabel = "";
        const dt = staff.preferredPhone.verifiedDate;
        const verifierLabel = `Verified by ${staff.preferredPhone.verifierFullName}`;
        if (dt) {
            verifiedDateLabel += DateService.getRelativeString(new Date(dt));
        }
        return verifierLabel + verifiedDateLabel;
    }, [staff.preferredPhone]);
    return (_jsxs("div", { className: "row", children: [_jsx("div", { className: "col-xl-8 col-12 mb-3", children: _jsxs("div", { className: "media", children: [_jsx("div", { className: "d-flex flex-column", children: _jsx(ProfilePicture, { person: staff, showProfilePicture: true, size: "lg" }) }), _jsxs("div", { className: "media-body ml-3", children: [_jsx(PageTitle, { children: staff.fullNameWithNickname }), _jsx("div", { children: staff.studentId }), staff.preferredPhone && staff.preferredPhone.number && (_jsxs("div", { children: [_jsxs("a", { title: staff.preferredPhone.phoneTypeName, href: `tel:${PersonPhoneDomainService.formatPhoneNumberForTelLink(staff.preferredPhone.number)}`, children: [staff.preferredPhone.number, " ", staff.preferredPhone.isSystemPhone && (_jsx("span", { className: "badge badge-dark", children: "Text Msg Only" }))] }), !staff.preferredPhone.isSystemPhone &&
                                            staff.preferredPhone &&
                                            staff.preferredPhone.verified && (_jsx(FAIcon, { icon: "check", title: phoneVerifiedTitle, className: "ml-2" }))] }))] })] }) }), _jsx("div", { className: "col-xl-4 col-12 mb-3" })] }));
};
export default StaffAboveTabs;
